<div *ngIf="bannerContent" [innerHtml]="bannerContent | safeHtml"></div>